import React, { useState, useEffect } from 'react';
import './Courses.css';
import ClassesList from '../../Components/ClassesList/ClassesList';
import { Input, Button } from 'antd';
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';
import CategoriesList from '../../Components/CategoriesList/CategoriesList';
import CoursesLoading from '../../Components/CoursesLoading/CoursesLoading';
import axiosInstance from '../../Config/axiosConfig';
import FilterModal from '../../Components/FilterModal/FilterModal';
import examPromo from '../../Assets/exams.png'
import { useNavigate } from 'react-router-dom';

function Courses() {
  const [categories, setCategories] = useState([]);
  const [subjectCategories, setSubjectCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedEducationLevelId, setSelectedEducationLevelId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // Check on load
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post('Public/get-lookups');
        console.log("lookups response:", response);
        const data = response.data;
        if (data.code === 200 && data.data) {
          const formattedCategories = data.data.educationLevels.map((level) => ({
            id: level.id,
            name: level.name,
            submenu: data.data.educationClasses
              .filter((cls) => cls.education_level_id === level.id)
              .map((cls) => ({ id: cls.id, name: cls.name })),
          }));

          const formattedSubjects = data.data.subjects.map((subject) => ({
            id: subject.id,
            name: subject.name,
          }));

          setCategories(formattedCategories);
          setSubjectCategories(formattedSubjects);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally { 
        setLoading(false);
      }   
    };

    fetchData();
  }, []);

  const handleFilterSelect = (id) => {
    setSelectedEducationLevelId(id);
    setSelectedCategoryId(null);
    setSearchQuery('');
  };

  const handleSubjectSelect = (subjectId) => {
    setSelectedCategoryId(subjectId);
    setSearchQuery('');
  };

  if (loading) {
    return <CoursesLoading />;
  }
 
  const handleExams = () => navigate("/exam-system")

  return (
    <div className="courses-container">
      <div className="courses-layout">
        <div className="course-content">
         {isMobile && (
            <img
              src={examPromo}
              alt="exam-navigation-card"
              className='exam-resize-mode'
              onClick={handleExams}
            />
          )}
          <div className="course-header">
            <div className="header-left">
              <span className="classes-title">Classes</span>
            </div>
            {isMobile ? (
              <Button 
                icon={<FilterOutlined />} 
                onClick={() => setIsFilterModalOpen(true)}
                className="mobile-filter-button"
              />
            ) : (
              <div className='filter-toggle' onClick={() => setIsFilterModalOpen(true)}>
                <span className='filter-toggle-text'>All Filters</span> 
              </div>
            )}
          </div>

          <FilterModal
            visible={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            categories={categories}
            isMobile={isMobile}
            onFilterSelect={handleFilterSelect}
            selectedEducationLevelId={selectedEducationLevelId}
          />

          <div className="search-box">
            <Input
              prefix={<SearchOutlined className="search-icon" />}
              className="search-input"
              placeholder="Search for classes, teachers, skills"
              size={isMobile ? 'large' : 'middle'}
              onChange={handleSearch}
              value={searchQuery}
              allowClear
            />
          </div>

          <div className="course-categories-list">
            <CategoriesList
              categories={subjectCategories}
              selectedCategory={selectedCategoryId}
              setSelectedCategory={handleSubjectSelect}
              isMobile={isMobile}
            />
          </div>

          <ClassesList
            educationLevelId={selectedEducationLevelId}
            subjectId={selectedCategoryId}
            isMobile={isMobile}
            searchQuery={searchQuery}
          />
        </div>
      </div>
    </div>
  );
}

export default Courses;